//@flow
import componentLocator from '../../assets/javascripts/component_locator'
import type DataTable from '../data_table/data_table'
import type FilterPanel from './filter_panel';

export default class TagSection {
    groupName: string;
    dataTables: DataTable[];
    panel: FilterPanel;
    isOpen: boolean;
    header: JQuery
    content: JQuery
    checkboxes: JQuery
    accordion: JQuery

    constructor(groupName: string, panel: FilterPanel, element: Element) {
        this.groupName = groupName;
        this.isOpen = false;
        this.panel = panel;

        this.findChildren(element);
        this.initEvents(panel);
    }

    findChildren(element: Element) {
        this.header = $(element.children[0]);
        this.accordion = this.header.find('.accordion');
        this.accordion_i = this.accordion.find('i')
        this.content = $(element.children[1]);
        this.checkboxes = this.content.find('li');
    }

    initEvents(panel: FilterPanel) {
        this.accordion.on('click', () => this.toggle());
        this.header.find('input').keyup(e => this.filter(($(e.target).val(): string)));

        this.checkboxes.each((i, checkbox) => {
            $(checkbox).find('input').change(e => {
                this.handleCheckboxChecked(panel, e);
            })
        });
    }

    handleCheckboxChecked(panel: FilterPanel, e: Event) {
        let filter = decodeURIComponent($(e.target).attr('data-value'));
        let checked = $(e.target).prop('checked');
        panel.dataTables.forEach(dt =>
             dt.toggleFilter('Tags', checked).tagSearch(filter, this.groupName));
        let key = `${this.groupName}-${filter}`;
        if (checked) {
            panel.showPill(key, filter, () => $(e.target).click());
        } else {
            panel.removePill(key);
        }
    }

    toggle(isOpen: ?boolean) {
        isOpen = this.isOpen = isOpen == null ? !this.isOpen : isOpen;

        this.content.toggleClass('hidden', !isOpen);
        this.accordion_i.toggleClass('fa-angle-down', !isOpen);
        this.accordion_i.toggleClass('fa-angle-up', isOpen);
        if (!isOpen) return;

        this.panel.tagSections.forEach(section => {
            if (section !== this) section.toggle(false);
        });
    }


    filter(filterText: string) {
        this.toggle(true);
        this.checkboxes.each((i, checkbox) => {
            let label = $(checkbox).find('label').text().toLowerCase().trim();
            $(checkbox).toggleClass('hidden', !label.includes(filterText.toLowerCase()));
        })
    }
}